const topics = [
  { id: 1, label: '#暗夜追凶大结局', heat: '128万' },
  { id: 2, label: '#长安秘事录', heat: '96万' },
  { id: 3, label: '#暑期档追剧', heat: '87万' },
  { id: 4, label: '#妖精视频新剧', heat: '76万' },
  { id: 5, label: '#桃花视频独播', heat: '68万' },
  { id: 6, label: '#1080P高清', heat: '59万' },
  { id: 7, label: '#悬疑剧推荐', heat: '52万' },
  { id: 8, label: '#山海异兽录', heat: '47万' },
  { id: 9, label: '#苹果视频热播', heat: '41万' },
  { id: 10, label: '#榴莲视频新番', heat: '38万' },
  { id: 11, label: '#豆花视频电影', heat: '35万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            大家都在聊
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            当前最受关注的热播剧集和追剧话题，看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group cursor-pointer bg-background-50 rounded-full px-4 py-2.5 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all flex items-center gap-2"
            >
              <span className="text-foreground-800 text-sm group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-foreground-400 text-xs flex-shrink-0">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}